import * as React from "react";
import { styled } from "@mui/material";
import { ClinicColors } from "../styles/clinicTheme";

//region [[ Styles ]]

const VDivider = styled("div")({
  borderRight: "1px solid " + ClinicColors.borders,
  borderTop: "1px solid " + ClinicColors.borders,
  alignSelf: "stretch",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface VerticalDividerProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const VerticalDivider = ({ ...props }: VerticalDividerProps) => {
  return <VDivider className="vertical-d" />;
};
